// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallEnd24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22.6856 14.2028L20.9876 15.9007C20.1596 16.745 18.8341 16.8447 17.8837 16.1296C17.3116 15.6909 16.6918 15.3183 16.0376 15.0196L15.8741 14.9377C15.1304 14.5283 14.6598 13.7455 14.655 12.8832L14.6552 12.0282L14.4138 11.9749C12.8201 11.6502 11.1771 11.6502 9.58344 11.9749L9.34344 12.0282L9.34228 12.8874C9.33748 13.7458 8.86686 14.5283 8.1245 14.9371L7.96133 15.0189C7.30551 15.3183 6.68565 15.6909 6.10821 16.1337C5.15254 16.8531 3.80946 16.7421 2.99787 15.8888L1.29686 14.1878C0.825922 13.7207 0.573744 13.0767 0.602282 12.4139C0.63082 11.7512 0.937429 11.1313 1.45729 10.6977C3.48551 9.06708 5.86795 7.93492 8.40641 7.39368C10.7572 6.86966 13.1946 6.86966 15.539 7.39228C18.0947 7.93851 20.4859 9.07908 22.5278 10.7291C23.0355 11.1527 23.3419 11.7702 23.372 12.4308C23.4021 13.0913 23.1532 13.7341 22.6856 14.2028ZM18.7906 14.9348C19.1339 15.193 19.6155 15.1568 19.9163 14.8501L21.624 13.1423C21.7937 12.9722 21.8841 12.7386 21.8732 12.4986C21.8623 12.2587 21.751 12.0344 21.5756 11.8879C19.7261 10.3935 17.5505 9.35574 15.2187 8.85735C13.0828 8.38124 10.8683 8.38124 8.72564 8.85883C6.40986 9.35262 4.24219 10.3827 2.40732 11.8578C2.22229 12.0121 2.11091 12.2373 2.10054 12.4781C2.09018 12.7188 2.18178 12.9528 2.35502 13.1246L4.07118 14.8411C4.37071 15.1559 4.85861 15.1962 5.20038 14.939C5.8622 14.4314 6.57932 14.0003 7.33971 13.6532C7.64396 13.5152 7.84008 13.2127 7.84194 12.8828L7.84194 11.4408C7.84194 11.1032 8.06753 10.8072 8.39307 10.7177C10.7527 10.0687 13.2438 10.0687 15.6035 10.7177C15.929 10.8072 16.1546 11.1032 16.1546 11.4408L16.1546 12.8786C16.1565 13.2127 16.3526 13.5152 16.6585 13.6539C17.4172 14.0003 18.1344 14.4314 18.7906 14.9348Z"
				/>
			</Svg>
		);
	}
);
SvgCallEnd24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallEnd24;
